export default {
        created: function () {
                console.log('Printing from the Mixin')
        },
        methods: {
                getKey(cardid, contentid){
                        return `${cardid}_${contentid}`
                },
                getCardKey(cardid, content){
                        return {"category_id": cardid, 
                        "content_id":content.id,
                        "type": content.type,
                        "title":content.title}
                },
                computedIcon(type){
                        if(type=="tutorial"){
                          return 'mdi-book-play'
                        }else if (type=='quiz'){
                          return 'mdi-school'
                        }else{
                          return "mdi-flag"
                        }
                },
        }
}